export default __webpack_public_path__ + "static/grouping-dont-630f50e20def932838c75e7c90541bc897ff5e30985a3fb3dba4de1afb436da5.png";